import styled from "styled-components";
import { Row, Col } from "../../components/ui/wrapper";

export const CareerOverviewRow = styled(Row)`
  padding: 30px;
  border-radius: 5px;
  background-color: ${props =>
    props.isOddRow ? props.theme.colors.white : props.theme.colors.grayThree};
`;

export const CareerOverviewCenteredCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
`;


export const BoxIconInner = styled.div`
  padding: 30px 15px;
  border-radius: 5px;
  transition: ${props => props.theme.transition};
  text-align: center;
  display: flex;
`;

export const BoxIconImg = styled.div`
  max-width: 80px;
  flex-basis: 80px;
  margin-right: 10px;
  color: #333333;
`;

export const BoxIconContent = styled.div`
  text-align: left;
  max-width: calc(100% - 90px);
  flex-basis: calc(100% - 90px);
`;

export const BoxIcontitle = styled.h5`
  font-weight: 500;
  line-height: 1.25;
  margin-bottom: 12px;
`;

export const BoxIconText = styled.p`
  margin-bottom: 0;
`;

export const BoxIconBtn = styled.div`
  margin-top: 20px;
`;

export const BoxIconWrap = styled.div`
  &:hover {
    ${BoxIconInner} {
      border-color: #fff;
      transform: translateY(-5px);
      background: #fff;
      box-shadow: 0 0 40px rgba(51, 51, 51, 0.1);
    }
  }
`;

export const Title = styled.h5`
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1.41;
  font-size: 24px;
  vertical-align: middle;
  color: ${props => props.color || "#333333"};
`;

export const ListGroupWrap = styled.div`
  padding: 20px;
`;

export const Excerpt = styled.div`
  padding: 20px;
`;

export const Heading = styled.h2`
font-size: "30px";
line-height: "36px";
font-weight: "400";
margin-bottom: "30px"
`;

export const ApplyJobFormContainer = styled.div`
margin:0px;
padding:0px;
font-size:18px;
`;
